import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  private permissions: string[] = [];

  constructor() {
    const storedPermissions = localStorage.getItem('userPermissions');
    this.permissions = storedPermissions ? JSON.parse(storedPermissions) : [];
  }

  hasPermission(permission: string): boolean {
    return this.permissions.includes('*') || this.permissions.includes(permission);
  }
}